import React from 'react';
export function ContentSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-6" data-id="element-107">
          📚 ESTO ES TODO LO QUE INCLUYE:
        </h2>

        <div className="space-y-3" data-id="element-108">
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-4 rounded-lg shadow-lg" data-id="element-109">
            <h3 className="text-2xl font-black text-white mb-1" data-id="element-110">
              📘 TOMO 1: Introducción al dinero
            </h3>
            <p className="text-lg text-white" data-id="element-111">
              Aprende qué es el dinero y cómo funciona
            </p>
          </div>

          <div className="bg-gradient-to-r from-green-500 to-green-600 p-4 rounded-lg shadow-lg" data-id="element-112">
            <h3 className="text-2xl font-black text-white mb-1" data-id="element-113">
              📘 TOMO 2: Cómo administrar el dinero
            </h3>
            <p className="text-lg text-white" data-id="element-114">
              Sistema de frascos y organización
            </p>
          </div>

          <div className="bg-gradient-to-r from-purple-500 to-purple-600 p-4 rounded-lg shadow-lg" data-id="element-115">
            <h3 className="text-2xl font-black text-white mb-1" data-id="element-116">
              📘 TOMO 3: Hábitos que crean riqueza
            </h3>
            <p className="text-lg text-white" data-id="element-117">
              Disciplina y comportamiento financiero
            </p>
          </div>

          <div className="bg-gradient-to-r from-orange-500 to-orange-600 p-4 rounded-lg shadow-lg" data-id="element-118">
            <h3 className="text-2xl font-black text-white mb-1" data-id="element-119">
              📘 TOMO 4: Pensar como rico
            </h3>
            <p className="text-lg text-white" data-id="element-120">
              Mentalidad, generación de dinero y emprendimiento
            </p>
          </div>

          <div className="bg-gradient-to-r from-red-500 to-red-600 p-4 rounded-lg shadow-lg" data-id="element-121">
            <h3 className="text-2xl font-black text-white mb-1" data-id="element-122">
              📘 TOMO 5: Sistema financiero familiar
            </h3>
            <p className="text-lg text-white" data-id="element-123">Cómo aplicar todo en casa</p>
          </div>

          <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 p-4 rounded-lg shadow-lg" data-id="element-124">
            <h3 className="text-2xl font-black text-white mb-1" data-id="element-125">
              📘 TOMO 6: Dinero, valores y legado
            </h3>
            <p className="text-lg text-white" data-id="element-126">
              Formación consciente y emocional
            </p>
          </div>
        </div>

        <div className="mt-6 bg-white p-5 rounded-lg shadow-lg" data-id="element-127">
          <h3 className="text-2xl md:text-4xl font-black text-gray-800 mb-3" data-id="element-128">
            👨‍👩‍👧 ¿PARA QUIÉN ES?
          </h3>
          <ul className="space-y-2 mb-4" data-id="element-129">
            <li className="flex items-start" data-id="element-130">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-131">✔</span>
              <span className="text-xl" data-id="element-132">Padres con hijos de 5 a 15 años</span>
            </li>
            <li className="flex items-start" data-id="element-133">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-134">✔</span>
              <span className="text-xl" data-id="element-135">Personas que quieren educar mejor</span>
            </li>
            <li className="flex items-start" data-id="element-136">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-137">✔</span>
              <span className="text-xl" data-id="element-138">
                Familias que buscan un sistema simple
              </span>
            </li>
          </ul>

          <h3 className="text-2xl md:text-4xl font-black text-red-600 mb-3" data-id="element-139">
            ❌ ¿PARA QUIÉN NO ES?
          </h3>
          <ul className="space-y-2" data-id="element-140">
            <li className="flex items-start" data-id="element-141">
              <span className="text-red-600 font-bold mr-3" data-id="element-142">❌</span>
              <span className="text-lg" data-id="element-143">Personas que no aplican</span>
            </li>
            <li className="flex items-start" data-id="element-144">
              <span className="text-red-600 font-bold mr-3" data-id="element-145">❌</span>
              <span className="text-lg" data-id="element-146">Quienes buscan soluciones mágicas</span>
            </li>
            <li className="flex items-start" data-id="element-147">
              <span className="text-red-600 font-bold mr-3" data-id="element-148">❌</span>
              <span className="text-lg" data-id="element-149">
                Padres que no quieren involucrarse
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}
export default ContentSection;